import { GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import { debounce } from 'lodash';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { State } from '@progress/kendo-data-query';
import { QueryObserverResult } from 'react-query';

interface UseServerKendoGridReactQueryDataHandlerProps {
    gridState: State;
    setGridState: Dispatch<SetStateAction<State>>;
    gridQuery: QueryObserverResult<any, unknown>;
}

const useServerKendoGridReactQueryDataHandler = ({
    gridState,
    setGridState,
    gridQuery,
}: UseServerKendoGridReactQueryDataHandlerProps) => {
    useEffect(() => {
        gridQuery.refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gridState]);

    const handleDataStateChange = debounce((e: GridDataStateChangeEvent) => {
        setGridState(e.dataState);
    }, 300);

    return handleDataStateChange;
};

export default useServerKendoGridReactQueryDataHandler;
